import React, { Fragment, useState, useEffect } from "react";

import EvidencijeSteps from "../../components/EvidencijeComponents/EvidencijeSteps";
import ActionSection from "../../components/EvidencijeComponents/ActionSection";
import ModalComponent from "../../components/UI/Modal/Modal";

import { useForm, useMultiStep } from "../../hooks";
import StepButtonsGroup from "../../components/EvidencijeComponents/StepButtonsGroup";
import FormEntrySection from "../../components/EvidencijeComponents/FormEntrySection";
import RecordSection from "../../components/EvidencijeComponents/RecordSection";
import SearchSection from "../../components/EvidencijeComponents/SearchSection";
import FormSection from "../../components/EvidencijeComponents/FormSection";
import {
  POLICE_OSIGURANJA_INITIAL_STATE,
  IZVJESCA_INITIAL_STATE,
  UGOVOR_SJI_INITIAL_STATE,
  RASKID_UGOVORA_INITIAL_STATE,
  REVIDIRANI_SJI_INITIAL_STATE,
} from "../../constants";
import { Row as RowB, Col as ColB, Row, Col } from "react-bootstrap";
import axiosInstance from "../../api/utils/axiosInstance";

import { validateAndSubmitForms } from "../../api/services/validateAndSubmit.Forms";
import TableSection from "../../components/EvidencijeComponents/TableSection";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { SignatureModal } from "../Signature/SignatureModal";

const EvidencijeContainer = ({ role, isAuthenticated, history }) => {
  const [selectedAction, setSelectedAction] = useState("");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [initialItemCount, setInitialItemCount] = useState(1);
  const [steps, setSteps] = useState([
    {
      key: 1,
      title: "Odabir akcije",
      status: "wait",
      icon: "todo",
    },
    {
      key: 2,
      title: "Unos",
      status: "wait",
      icon: "todo",
    },
  ]);

  const [showPotpisivanjeConfirmationModal, setShowPotpisivanjeConfirmationModal] = useState(false);
  const [confirmEvidencijaSubmitModal, setConfirmEvidencijaSubmitModal] =useState(false);

  const showEvidencijaSubmitModal = () => {
    setConfirmEvidencijaSubmitModal(true);
  };

  const hideEvidencijaSubmitModal = () => {
    setConfirmEvidencijaSubmitModal(false);
  };

  const hidePotpisivanjeConfirmationModal = () => {
    setShowPotpisivanjeConfirmationModal(false);
    setIdPredPosEvid("");
    fetchEvidencijeTableData();
  };

  const [evidencije, setEvidencije] = useState([]);
  const [searchValues, setSearchValues] = useState({
    oib: "",
    registarskiBroj: "",
    vrstaEvidencije: 0,
  });
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showConfirmActionModal, setShowConfirmationModal] = useState(false);
  const [showTransitionToUpdateModal, setShowTransitionToUpdateModal] =
    useState(false);

  const [idPredPosEvid, setIdPredPosEvid] = useState("");
  const {
    currentStep,
    setCurrentStep,
    next,
    prev,
    getStatus: multiStepStatus,
  } = useMultiStep();
  const {
    values,
    setValues,
    handleInputChange,
    handleDropdown,
    handleDateChange,
    handleSingleFileUpload,
    handleRadioButton,
    handleNumberInput,
    handleDecimalNumberInput,
    downloadAttachments,
    removeAttachment,
    handleMultiFileUpload,
  } = useForm(selectedRecord);
  const [clicked, setClicked] = useState(false);

  const handleActionChange = ({ target }) => {
    const { value } = target;
    setSelectedAction(value);
    if (value === "unos") {
      setSteps([
        {
          key: 1,
          title: "Odabir akcije",
          status: "wait",
          icon: "todo",
        },
        {
          key: 2,
          title: "Unos",
          status: "wait",
          icon: "todo",
        },
      ]);
    } else if (value === "pregled") {
      setSteps([
        {
          key: 1,
          title: "Odabir akcije",
          status: "wait",
          icon: "todo",
        },
        {
          key: 2,
          title: "Pregled",
          status: "wait",
          icon: "todo",
        },
      ]);
    }
  };

  const transitionToUpdate = () => {
    setSteps([
      {
        key: 1,
        title: "Odabir akcije",
        status: "wait",
        icon: "todo",
      },
      {
        key: 2,
        title: "Pregled",
        status: "wait",
        icon: "todo",
      },
    ]);
    hideTransitionToUpdateModal();
    setSelectedAction("pregled");
    setSelectedRecord(null);
  };

  const handleRecordChange = ({ target }) => {
    const { value } = target;

    switch (value) {
      case "1":
        setValues(POLICE_OSIGURANJA_INITIAL_STATE);
        break;
      case "2":
        setValues(IZVJESCA_INITIAL_STATE);
        break;
      case "3":
        setValues(UGOVOR_SJI_INITIAL_STATE);
        break;
      case "4":
        setValues(RASKID_UGOVORA_INITIAL_STATE);
        break;
      case "5":
        setValues(REVIDIRANI_SJI_INITIAL_STATE);
        break;
      default:
        break;
    }

    setSelectedRecord(value);
  };

  const fetchEvidencijeTableData = async () => {
    const { data } = await axiosInstance.get(
      "/posebne-evidencije?oib=&regBroj=&vrEvidencije=0&page=1&offset=10&init=1"
    );
    if (data.result.length > 0) {
      const dataSource = data.result.map((element, index) => {
        return {
          ...element,
          key: index + 1,
        };
      });
      setInitialItemCount(data.size);
      setEvidencije(dataSource);
    } else {
      setEvidencije([]);
    }
  };

  const cleanup = () => {
    setSelectedAction("");
    setSelectedRecord(null);
    setValues({});
    setCurrentStep(1);
  };

  const handleSubmit = (e) => {
    validateAndSubmitForms(
      values,
      selectedRecord,
      cleanup,
      false,
      openTransitionToUpdateModal,
      setIdPredPosEvid,
      setShowPotpisivanjeConfirmationModal,
      role,
      fetchEvidencijeTableData
    );
    hideEvidencijaSubmitModal();
  };

  const handleUpdateSubmit = (e) => {
    validateAndSubmitForms(
      values,
      selectedRecord,
      hideUpdateModal,
      "update",
      openTransitionToUpdateModal,
      setIdPredPosEvid,
      setShowPotpisivanjeConfirmationModal,
      role,
      fetchEvidencijeTableData
    );
    setClicked(true);
  };

  const handleSearchChange = ({ target }) => {
    const { name, value } = target;

    setSearchValues({ ...searchValues, [name]: value });
  };

  const handleDropdownChange = ({ target }) => {
    setSearchValues({ ...searchValues, vrstaEvidencije: target.value });
  };

  const handleUpdateButtonClicked = (id) => async (e) => {
    try {
      const { data } = await axiosInstance.get(`/posebne-evidencije/${id}`);
      data.obrisaniDokumenti = [];
      const { idPosEvid } = data;

      switch (idPosEvid) {
        case 1:
          data.dokumentPoliceOsiguranjaOld = data.dokumentPoliceOsiguranja;
          data.dokumentPoliceOsiguranja = [];
          data.obavijestONastalimPromjenamaOld =
            data.obavijestONastalimPromjenama;
          data.obavijestONastalimPromjenama = [];
          break;
        case 2:
          data.obavijestOIznimciOld = data.obavijestOIznimci;
          data.obavijestOIznimci = [];
          data.dokumentiOld = data.dokumenti;
          data.dokumenti = [];
          break;
        case 3:
          data.dokumentiOld = data.dokumenti;
          data.dokumenti = [];
          break;
        case 4:
          data.dokumentiOld = data.dokumenti;
          data.dokumenti = [];
          break;
        case 5:
          data.dokumentiOld = data.dokumenti;
          data.dokumenti = [];
          break;
      }

      setValues(data);
      setSelectedRecord(String(idPosEvid));
      setShowUpdateModal(true);
    } catch (e) {
      console.log(e);
    }
  };

  const hideUpdateModal = () => {
    setShowUpdateModal(false);
    setSelectedRecord(null);
    setValues({});
    setClicked(false);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    const { oib, registarskiBroj, vrstaEvidencije } = searchValues;

    const { data } = await axiosInstance.get(
      `/posebne-evidencije?oib=${oib}&regBroj=${registarskiBroj}&vrEvidencije=${Number(
        vrstaEvidencije
      )}&page=1&offset=10&init=0`
    );
    if (data.result.length > 0) {
      const dataSource = data.result.map((element, index) => {
        return {
          ...element,
          key: index + 1,
        };
      });
      setEvidencije(dataSource);
      setInitialItemCount(data.size);
    } else {
      setEvidencije([]);
      toast.info("Za navedene parametre nema podataka.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const openConfirmActionModal = (idPredPosEvid) => (e) => {
    setShowConfirmationModal(true);
    setIdPredPosEvid(idPredPosEvid);
  };

  const hideConfirmActionModal = () => {
    setShowConfirmationModal(false);
    setIdPredPosEvid("");
  };

  const openTransitionToUpdateModal = () => {
    setShowTransitionToUpdateModal(true);
  };

  const hideTransitionToUpdateModal = () => {
    setShowTransitionToUpdateModal(false);
  };

  const printPdf = async () => {
    try {
      const { data } = await axiosInstance.get(
        `/posebne-evidencije/print/${idPredPosEvid}`,
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(
        new Blob([data], { type: "application/pdf" })
      );

      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "posebne-evidencije");
      document.body.appendChild(link);
      link.click();
    } catch (e) {
      if (e.reponse.data.msg) {
        toast.info(e.response.data.msg, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        toast.info("Nešto je pošlo po krivu. Molimo pokušajte ponovno!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } finally {
      hideConfirmActionModal();
    }
  };

  // search dropdown init

  const getDropdownOptions = () => {
    let dropdownData = [];
    let dropdownFilterData = [
      { id: 1, name: "Polica osiguranja" },
      { id: 2, name: "Izvješće o transparentnosti" },
      { id: 3, name: "Ugovor o reviziji sa SJI" },
      { id: 4, name: "Raskid ugovora sa SJI" },
      { id: 5, name: "Obavijest iz članka 14. Uredbe (EU) br. 537/2014" },
    ];

    dropdownData.push({ id: 0, name: "Sve evidencije" });
    dropdownFilterData.map((element) => dropdownData.push(element));

    let dropdownOptions = dropdownData.map((element) => (
      <option key={element.id} value={element.id}>
        {element.name}
      </option>
    ));

    return dropdownOptions;
  };

  //paginacija

  const onPageChanged = async (page) => {
    const { data } = await axiosInstance.get(
      `/posebne-evidencije?oib=${searchValues.oib}&regBroj=${
        searchValues.registarskiBroj
      }&vrEvidencije=${Number(
        searchValues.vrstaEvidencije
      )}&page=${page}&offset=10&init=0`
    );
    if (data.result.length > 0) {
      const dataSource = data.result.map((element, index) => {
        return {
          ...element,
          key: (page - 1) * 10 + index + 1,
        };
      });
      setInitialItemCount(data.size);
      setEvidencije(dataSource);
    }
  };

  if (!isAuthenticated) {
    history.push("/");
  }

  return (
    <Fragment>
      <div className="evidencijeSteps">
      <EvidencijeSteps
        steps={steps}
        getStatus={multiStepStatus}
        currentStep={currentStep}
      /></div>
      <div className="steps-content">
        <ActionSection
          handleActionChange={handleActionChange}
          selectedAction={selectedAction}
          currentStep={currentStep}
          role={role}
        />
        {/*odaberi evidenciju */}
        <RecordSection
          currentStep={currentStep}
          handleRecordChange={handleRecordChange}
          selectedRecord={selectedRecord}
          selectedAction={selectedAction}
        />
        <FormEntrySection
          handleRadioButton={handleRadioButton}
          handleSingleFileUpload={handleSingleFileUpload}
          handleMultiFileUpload={handleMultiFileUpload}
          handleDropdown={handleDropdown}
          selectedAction={selectedAction}
          handleRecordChange={handleRecordChange}
          currentStep={currentStep}
          selectedRecord={selectedRecord}
          values={values}
          handleInputChange={handleInputChange}
          handleDateChange={handleDateChange}
          handleNumberInput={handleNumberInput}
          handleDecimalNumberInput={handleDecimalNumberInput}
        />

        {/* pregled */}
        <SearchSection
          handleSearchChange={handleSearchChange}
          handleDropdownChange={handleDropdownChange}
          handleSearchSubmit={handleSearchSubmit}
          currentStep={currentStep}
          selectedAction={selectedAction}
          values={searchValues}
          dropdownOptions={getDropdownOptions()}
        />
        {/* tablica */}
        {evidencije.length > 0 && (
          <TableSection
            handleUpdateButtonClicked={handleUpdateButtonClicked}
            evidencije={evidencije}
            currentStep={currentStep}
            selectedAction={selectedAction}
            openConfirmActionModal={openConfirmActionModal}
            onPageChanged={onPageChanged}
            initialItemCount={initialItemCount}
          />
        )}
      </div>
      <ModalComponent
        size="xl"
        show={showUpdateModal}
        onHide={hideUpdateModal}
        title="Ažuriranje evidencija"
      >
        <FormSection
          removeAttachment={removeAttachment}
          downloadAttachments={downloadAttachments}
          handleUpdateSubmit={handleUpdateSubmit}
          handleSingleFileUpload={handleSingleFileUpload}
          handleMultiFileUpload={handleMultiFileUpload}
          handleDateChange={handleDateChange}
          handleInputChange={handleInputChange}
          values={values}
          clicked={clicked}
          selectedRecord={selectedRecord}
          handleRadioButton={handleRadioButton}
          update
          hideUpdateModal={hideUpdateModal}
          handleNumberInput={handleNumberInput}
          handleDecimalNumberInput={handleDecimalNumberInput}
        />
      </ModalComponent>
      <ModalComponent
        size="l"
        show={showConfirmActionModal}
        onHide={hideConfirmActionModal}
        title="Želite li ispisati posebnu evidenciju?"
      >
        <Row>
          <Col>
            <ButtonComponent block onClick={printPdf}>
              Da
            </ButtonComponent>
          </Col>
          <Col>
            <ButtonComponent
              block
              variant="danger"
              onClick={hideConfirmActionModal}
            >
              Ne
            </ButtonComponent>
          </Col>
        </Row>
      </ModalComponent>

      {/* Modal za potvrdu unosa  */}
      <ModalComponent
        size="l"
        show={confirmEvidencijaSubmitModal}
        onHide={hideEvidencijaSubmitModal}
        title="Jeste li sigurni da želite spremiti posebnu evidenciju?"
      >
        <Row>
          <Col>
            <ButtonComponent block onClick={handleSubmit}>
              Da
            </ButtonComponent>
          </Col>
          <Col>
            <ButtonComponent
              block
              variant="danger"
              onClick={hideEvidencijaSubmitModal}
            >
              Ne
            </ButtonComponent>
          </Col>
        </Row>
      </ModalComponent>

      {/* Modal za potpisivanje */}
      <SignatureModal show={showPotpisivanjeConfirmationModal} zahtjevAtrId={idPredPosEvid} dataType="evidencija"
       onHide={hidePotpisivanjeConfirmationModal} onCancel={hidePotpisivanjeConfirmationModal} onFinished={hidePotpisivanjeConfirmationModal}/>

      {/*Transition modal */}
      <ModalComponent
        size="l"
        show={showTransitionToUpdateModal}
        onHide={hideTransitionToUpdateModal}
        title="Posebna evidencija već unesena, želite li ažurirati postojeći zapis?"
      >
        <Row>
          <Col>
            {" "}
            <ButtonComponent block onClick={transitionToUpdate}>
              {" "}
              Da
            </ButtonComponent>
          </Col>
          <Col>
            {" "}
            <ButtonComponent
              variant="danger"
              block
              onClick={hideTransitionToUpdateModal}
            >
              Ne
            </ButtonComponent>
          </Col>
        </Row>
      </ModalComponent>

      <StepButtonsGroup
        selectedAction={selectedAction}
        selectedRecord={selectedRecord}
        next={next}
        prev={prev}
        currentStep={currentStep}
        handleSubmit={showEvidencijaSubmitModal}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    role: state.authentication.userData
      ? state.authentication.userData.roles[0].roleName
      : "",
    isAuthenticated: state.authentication.isAuthenticated,
  };
};

export default connect(mapStateToProps)(EvidencijeContainer);
